export default {
  // --- stock-transfer-meta.tsx ---
  Reason: "Raison",
  Type: "Type",
  Inbound: "Entrant",
  Outbound: "Sortant",
  "Receiver Shop": "Boutique réceptrice",
  "Sender Shop": "Boutique expéditrice",
  "Created At": "Créé le",
  Actions: "Actions",

  // --- stock-transfer-form.tsx ---
  "Receiver Shop ID": "ID de la boutique réceptrice",
  "Sender Shop ID": "ID de la boutique expéditrice",
  "Receiver Batch ID": "ID du lot récepteur",
  "Sender Batch ID": "ID du lot expéditeur",

  // --- select-stock-transfer.tsx ---
  "Stock Transfer": "Transfert de stock",
  "Search stock transfer by reason, receiver shop, sender shop, or batch":
    "Rechercher un transfert de stock par raison, boutique réceptrice, boutique expéditrice ou lot",
  "Edit Selection": "Modifier la sélection",
  "No stock transfers found": "Aucun transfert de stock trouvé",

  // --- create-stock-transfer-modal.tsx ---
  "Create a new stock transfer": "Créer un nouveau transfert de stock",

  // --- edit-stock-transfer-modal.tsx ---
  "Edit Stock Transfer": "Modifier le transfert de stock",

  // --- view-stock-transfer-modal.tsx & view-stock-transfer-block.tsx ---
  "General Information": "Informations générales",
  "Receiver Batch": "Lot récepteur",
  "Sender Batch": "Lot expéditeur",
  "Updated At": "Mis à jour le",

  // --- delete-stock-transfer-modal.tsx ---
  "Do you really want to delete this Stock Transfer?":
    "Voulez-vous vraiment supprimer ce transfert de stock ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- stock-transfer-list-block.tsx ---
  "Add stock transfer": "Ajouter un transfert de stock",

  // --- General ---
  Submit: "Soumettre",
  "Create stock transfer": "Créer un transfert de stock",
  "Transfer from": "Transférer depuis",
  "Sending shop": "Boutique d'expédition",
  "Inventory Item": "Article d'inventaire",
  Quantity: "Quantité",
  quantity: "quantité",
  "The available quantity is": "La quantité disponible est",
  "Reason (Optional)": "Raison (Facultatif)",
  "Sending Treasury account": "Compte de trésorerie expéditeur",
  "Transfer to": "Transférer vers",
  "Receiving shop": "Boutique de destination",
  "Receiver warehouse": "Entrepôt de destination",
  "Receiver Treasury account": "Compte de trésorerie destinataire",
  "Payment Date": "Date de paiement",
  "Submit the transfert": "Soumettre le transfert",
  Pending: "En attente",
  pending: "en attente",
  Approved: "Approuvé",
  approved: "approuvé",
  Completed: "Terminé",
  completed: "terminé",
  Cancelled: "Annulé",
  cancelled: "annulé",
  Product: "Produit",
  product: "produit",
  Qty: "Qté",
  qty: "qté",
  From: "De",
  from: "de",
  To: "À",
  to: "à",
  Status: "Statut",
  status: "statut",
  reason: "motif",
  actions: "actions",
};
